import { render, staticRenderFns } from "./DashBoard.vue?vue&type=template&id=4f844240&"
import script from "./DashBoard.vue?vue&type=script&lang=ts&"
export * from "./DashBoard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports